import request from "@/app/api/request";
import {
  ChangeChatInInvitationRequestModel,
  InvitationModel, InvitationStatusEnum,
  SendInvitationRequestModel,
  UpdateInvitationStatusRequestModel
} from "@/app/api/invitation/models";

export class InvitationRequests {
  static async sendInvitation(data: SendInvitationRequestModel): Promise<InvitationModel[]> {
    try {
      return await request.post<InvitationModel[]>('invitations/sendInvitations', {data});
    } catch (error: any) {
      throw error;
    }
  }

  static async changeInvitationStatus(query: UpdateInvitationStatusRequestModel): Promise<InvitationModel> {
    try {
      return await request.post<InvitationModel>('invitations/updateInvitationStatus', {query});
    } catch (error: any) {
      throw error;
    }
  }

  static async getMyInvitations(invitationStatus?: InvitationStatusEnum): Promise<InvitationModel[]> {
    try {
      return await request.get<InvitationModel[]>('invitations/getMyInvitations', {query: invitationStatus && {invitationStatus}});
    } catch (error: any) {
      throw error;
    }
  }

  static async getInvitationsByBatchId(batchId: string): Promise<InvitationModel[]> {
    try {
      return await request.get<InvitationModel[]>('invitations/getInvitationsByBatchId', {query: {batchId}});
    } catch (error: any) {
      throw error;
    }
  }

  static async deleteInvitation(invitationId: number): Promise<InvitationModel> {
    try {
      return await request.delete<InvitationModel>('invitations/deleteInvitation', {query: {invitationId}});
    } catch (error: any) {
      throw error;
    }
  }

  static async changeChatInInvitation(query: ChangeChatInInvitationRequestModel): Promise<InvitationModel> {
    try {
      return await request.patch<InvitationModel>('invitations/changeChatInInvitation', {query});
    } catch (error: any) {
      throw error;
    }
  }
}

